import { useMemo, useState } from 'react';
import Layout from 'src/components/Layout';
import SelectACompanyPlaceholder from 'src/components/SelectACompanyPlaceholder';
import PeriodViewContextProvider from 'src/sections/view_checkbook/PeriodViewContext';
import ViewCheckbookContextProvider from 'src/sections/view_checkbook/ViewCheckbookContext';
import ViewCheckbookNavbar from 'src/sections/view_checkbook/ViewCheckbookNavbar';
import ViewCheckbookTable from 'src/sections/view_checkbook/ViewCheckbookTable';
import ViewYearCheckbookNavbar from 'src/sections/view_checkbook/ViewYearCheckbookNavbar';
import YearViewContextProvider from 'src/sections/view_checkbook/YearViewContext';

const ViewCheckbook = () => {
  const [selectedView, setSelectedView] = useState<number>(0);
  const isPeriodView = useMemo(() => selectedView === 0, [selectedView]);

  return (
    <ViewCheckbookContextProvider
      selectedView={selectedView}
      setSelectedView={setSelectedView}
      isPeriodView={isPeriodView}
    >
      <PeriodViewContextProvider>
        <YearViewContextProvider>
          {isPeriodView ? <ViewCheckbookNavbar /> : <ViewYearCheckbookNavbar />}
          <Layout>
            <SelectACompanyPlaceholder display={<ViewCheckbookTable />} />
          </Layout>
        </YearViewContextProvider>
      </PeriodViewContextProvider>
    </ViewCheckbookContextProvider>
  );
};

export default ViewCheckbook;
